import { useQuery } from "@tanstack/react-query";
import { fetchSuchanaById } from "../services/suchanaService";

export const useFetchSuchanaDetails = (id) => useQuery({
    queryKey: ['suchana', id],
    queryFn: () => fetchSuchanaById(id),
    enabled: !!id
})
